import styled from "styled-components"

import { minWidth } from "utils"

import Heading from "components/article/heading"
import AccordionItem from "components/accordion-item"

export const Wrapper = styled.div`
  width: calc(100% - 5.4rem);
  margin: 0 2.7rem;
  padding-bottom: 4rem;

  ${minWidth.tablet`
    max-width: 58rem;
    margin: 0 auto;
  `}

  ${minWidth.hamburgerLarge`
    max-width: 72.5rem;
  `}
`

export const StyledHeading = styled(Heading)`
  margin: 0;
`

export const Accordion = styled(AccordionItem)`
  width: 100%;
  border-bottom: 0.1rem solid #22222233;
  background-color: ${({ background }) => background || "#fff"};

  > summary {
    padding: 0 0 1rem;

    > div {
      top: ${({ level }) => (level === 3 ? "0.5rem" : "1.1rem")};
      right: 0.3rem;
      border-color: #000;
    }
  }

  > div {
    margin-top: 1rem;

    > span > div {
      > p {
        padding: 0;
      }
      margin-left: 0;
      margin-right: 0;

      ${minWidth.desktopXL`
        max-width: 82.5rem;
      `}
    }
  }
`
